export const GROUP_ADMINISTRATION_BOTTOM_INPUT = "group_administration_bottom_input";
export const GROUP_ADMINISTRATION_TOP_BACK_BUTTON = "group_administration_top_back_button";
export const QUICK_ACTION_BAR_ICONS_CONTAINER = "quick_action_bar_icons_container";
